import { DEBUG } from '../api/Constants';

/**
 * Conditionally logs messages to the console based on DEBUG flag
 * @param {string} message - The message to log
 * @param {any} data - Optional data to log
 */
export const log = (message, data) => {
  if (DEBUG) {
    if (data !== undefined) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  }
};

/**
 * Conditionally logs error messages to the console based on DEBUG flag
 * @param {string} message - The error message to log
 * @param {Error|any} error - Optional error object to log
 */
export const error = (message, error) => {
  if (DEBUG) {
    if (error !== undefined) {
      console.error(message, error);
    } else {
      console.error(message);
    }
  }
};

/**
 * Conditionally logs warning messages to the console based on DEBUG flag
 * @param {string} message - The warning message to log
 * @param {any} data - Optional data to log
 */
export const warn = (message, data) => {
  if (DEBUG) {
    if (data !== undefined) {
      console.warn(message, data);
    } else {
      console.warn(message);
    }
  }
};

/**
 * Conditionally logs info messages to the console based on DEBUG flag
 * @param {string} message - The info message to log
 * @param {any} data - Optional data to log
 */
export const info = (message, data) => {
  if (DEBUG) {
    if (data !== undefined) {
      console.info(message, data);
    } else {
      console.info(message);
    }
  }
};
